const firebaseConfig = {
  apiKey: 'AIzaSyDstJTEal08sCtBSsETZQUnIrDERVK9ucg',
  authDomain: 'shareabook-e3e21.firebaseapp.com',
  projectId: 'shareabook-e3e21',
  storageBucket: 'shareabook-e3e21.firebasestorage.app',
  messagingSenderId: '402510968010',
  appId: '1:402510968010:web:412c47bf50b546ae8bf033',
  measurementId: 'G-WDSYGQYMYF',
}
export default firebaseConfig
